// reducers/routesReducer.js

import { FETCH_TRANSPORT_ROUTE_DETAILS_SUCCESS } from "appRedux/constants";


const initialState = {
  data: [],
};

const routesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TRANSPORT_ROUTE_DETAILS_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default routesReducer;
